import { css } from '@/styled-system/css';

const MOBILE_HEADER_HEIGHT = '48px';

export const detailHubContainer = css({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'hpxWhite',
  position: 'relative',
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': {
    minHeight: '100dvh',
  },
  md: {
    minHeight: 'unset',
    height: '100%',
    overflow: 'hidden',
  },
});

export const detailHeader = css({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: '1x',
  py: '1x',
  minHeight: MOBILE_HEADER_HEIGHT,
  zIndex: 'zIndexOverParent',
  willChange: 'transform',
  transitionProperty: 'background-color, border-bottom-color',
  transitionDuration: '0.3s',
  transitionTimingFunction: 'ease-out',
  md: {
    display: 'none',
  },
});

export const headerActions = css({
  display: 'flex',
  gap: '1x',
  alignItems: 'center',
});

export const detailMainContent = css({
  flex: 1,
  position: 'relative',
  md: {
    overflow: 'auto',
  },
});

export const detailMainContentPadding = css({
  paddingLeft: '2x',
  paddingRight: '2x',
  md: {
    paddingLeft: '4x',
    paddingRight: '4x',
  },
});

export const photoGalleryPadding = css({
  md: {
    px: '4x',
  },
});

export const listingTitle = css({
  fontSize: 'lg',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  margin: 0,
  paddingX: '2x',
  paddingTop: `calc(${MOBILE_HEADER_HEIGHT} + token(spacing.2x))`,
  paddingBottom: '2x',
  md: {
    fontSize: 'xl',
    paddingX: '4x',
    paddingTop: '2x',
  },
});

export const expandedCloseButton = css({
  position: 'static',
  top: 'unset',
  left: 'unset',
});

export const detailFooter = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1x',
  padding: '2x',
  backgroundColor: 'hpxWhite',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'hpxGrey400',
  minHeight: '72px',
  position: 'sticky',
  bottom: 0,
  zIndex: 'zIndexStep',
  md: {
    display: 'none',
  },
});

export const spokeFooterActions = css({
  display: 'flex',
  gap: '1x',
  width: '100%',
  maxWidth: '400px',
});
